import { withLayout } from 'pages/GuestLayout';

import ResetPasswordPage from './ResetPasswordPage';

export default withLayout('Reset Password', ResetPasswordPage);
